// extracted by mini-css-extract-plugin
export default {"wrapper":"RequireAuthentication_wrapper__uBO8h"};